import { sectionLabels } from "../section-labels";
/**
 * Collection products — locked. The product grid on a collection page,
 * filtered to the active category. Mirrors the all-products grid on the
 * homepage but with the category filter pre-applied. Cannot be removed
 * because it IS the collection page's commerce surface.
 *
 * Lives under `templates.collection` only.
 */
export const collectionProductsSchema = {
    type: "collection-products",
    name: sectionLabels["collection-products"],
    description: {
        ar: "شبكة منتجات الفئة. تطبق الفلتر تلقائيًا على الفئة الحالية.",
        en: "Product grid filtered to the current category.",
    },
    locked: true,
    criticalForSeo: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["collection"],
    settings: [
        {
            id: "showSortControl",
            type: "checkbox",
            label: { ar: "إظهار خيار الترتيب", en: "Show sort control" },
            default: true,
        },
        {
            id: "productsPerPage",
            type: "range",
            label: { ar: "عدد المنتجات بالصفحة", en: "Products per page" },
            min: 12,
            max: 96,
            step: 12,
            default: 36,
        },
        {
            id: "columnsDesktop",
            type: "select",
            label: { ar: "عدد الأعمدة على الكمبيوتر", en: "Desktop columns" },
            options: [
                { value: "3", label: { ar: "3", en: "3" } },
                { value: "4", label: { ar: "4", en: "4" } },
                { value: "5", label: { ar: "5", en: "5" } },
            ],
            default: "4",
        },
        {
            id: "emptyStateMessage",
            type: "textarea",
            i18n: true,
            label: { ar: "رسالة عند عدم وجود منتجات", en: "Empty-state message" },
            validate: { max: 200 },
        },
    ],
};
//# sourceMappingURL=collection-products.js.map